import {initModals} from './modules/modals/init-modals';
import {addToCartTable} from './modules/add-to-cart-table';
import {productPreview} from './modules/product-preview';
import {vehicles} from './modules/vehicles';
import {menu} from './modules/menu';
import {users} from './modules/users';
import {calendar} from './modules/calendar';
import {guarantee} from './modules/guarantee';
//import {demo} from './modules/demo';

window.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('load', () => {
        initModals();
        productPreview();
        addToCartTable();
        vehicles();
        menu();
        users();
        calendar();
        guarantee();
        //demo();
    })
});
